<template>
  <b-form-row>

    <b-modal id="ToggleSolicitacaoMovimentacaoModal" v-model="showModal" size="xl" :title="prefix + title"
      @close="closeModal" @hidden="closeModal" hide-footer>
      <b-card bg-variant="light">
        <b-card>
          <div>
            <span style="font-size: 16px">
              <strong>Nº Devolução:</strong> {{ solicitacao.id }}<br />
              <strong>Solicitante:</strong>
              {{ solicitacao.departamento.descricao }} <br />
              <strong>Status:</strong> {{ solicitacao.status.descricao }}<br />
            </span>
          </div>
        </b-card>

        <b-tabs content-class="mt-3">
          <b-tab title="Tarefas" active>
            <b-table id="detalhe-tarefas" responsive class="mt-2" small :items="tarefas" :fields="fieldsTarefas"
              :busy="this.busy" show-empty>

              <template #empty>
                <p>Nenhum registro encontrado</p>
              </template>

              <template v-slot:cell(agendamento)="row">
                <b-button v-if="isAproavacaoExecucaoRetirada(row.item)" :id="'agendar-tarefa' + row.index" pill
                  size="sm" variant="primary" @click="abrirModalAgendamento(row.item)">
                  <b-icon icon="calendar" />
                  <b-tooltip :target="'agendar-tarefa' + row.index" title="Agendamento de Retirada"></b-tooltip>
                </b-button>


              </template>



              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template v-slot:cell(action)="{ item }">
                <div class="text-center">
                  <b-button id="iniciar" v-if="isBtnIniciarVisible(item)" pill size="sm" variant="primary"
                    title="Iniciar a tarefa atual..." @click="iniciarTarefa(item)">
                    <b-icon icon="file-earmark-play" />
                  </b-button>


                  <b-button v-if="
                    isBtnContinuarVisible(item)
                  " pill size="sm" variant="primary" title="Continuar a tarefa atual..."
                    @click="abrirModalTarefa(item)">
                    <b-icon icon="file-earmark-bar-graph" />
                  </b-button>
                </div>
              </template>


              <template v-slot:cell(detalheTarefa)="row">
                <b-button :id="row.index + 'visualizar-tarefa'" class="my-2" size="sm" pill variant="primary"
                  @click="abrirModalTarefaDetalhar(row.item)">
                  <b-icon icon="file-earmark-text" />
                  <b-tooltip :target="row.index + 'visualizar-tarefa'" title="Visualizar a tarefa atual..."></b-tooltip>
                </b-button>

              </template>
            </b-table>
          </b-tab>
          <b-tab title="Itens">
            <b-table id="t-itens" responsive class="mt-2" small :items="itens" :fields="fieldsItens" :busy="this.busy"
              show-empty>
              <template #empty>
                <p>Nenhum registro encontrado</p>
              </template>

              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>



            </b-table>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-modal>
    <TarefaForm @close="fecharModalTarefa" :id="idTarefa" :isVisualizacao="isVisualizacao" v-if="mostrarTarefaForm"
      :prefix="prefix + title + ' > '"></TarefaForm>

    <ModalLogin :tarefa="tarefa" @usuarioAutenticado="abrirModalTarefaShow" :isPedido="false" @close="cancelarLogin"
      :disabledLogin="true" :login="usuario.login" v-if="showLogin">
    </ModalLogin>


    <ModalAgendamento :isVisualizacao="isVisualizarAgendamento" @close="fecharAgendamento" v-if="mostrarAgendamento"
      :tarefa="tarefa" :prefix="prefix + title + ' > '"></ModalAgendamento>

  </b-form-row>
</template>

<script>
import TarefaForm from "./TarefaForm.vue";
import ResourceService from "@/core/api/ResourceService"
import ConfirmMixin from "@/core/mixins/confirm"
import Formatters from "@/core/mixins/formatters"
import Resource from "@/core/mixins/resource"
import moment from "moment"
import { ListResourceMixin } from "@/core/mixins/resource"
import { FormResourceMixin } from "@/core/mixins/resource"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import StatusEnum from "@/core/utils/StatusEnum";
import TipoTarefaSolMovIBPEnum from "@/core/utils/TipoTarefaSolMovIBPEnum";
import ModalAgendamento from '@/core/components/Modals/ModalAgendamento.vue';
import ModalLogin from "@/modules/almoxarifados/pedidos/ModalLogin.vue";

export default {
  mixins: [
    Formatters,
    ConfirmMixin,
    Resource.FormResourceMixin,
    ListResourceMixin,
    FormResourceMixin,
  ],
  components: {
    ModalLogin,
    TarefaForm,
    ModalAgendamento

  },

  props: {

    solicitacao: {
      type: Object,
      required: true,
    },
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Detalhes",
    },
  },

  data() {
    return {
      showLogin: false,
      exigeLogin: false,
      isVisualizarAgendamento: false,
      tarefa: {},
      mostrarAgendamento: false,
      isVisualizacao: false,
      idTarefa: null,
      mostrarTarefaForm: false,
      selectedItem: {},
      busy: false,
      showModal: true,
      itens: [],
      tarefas: [],
      usuario:{},
    }
  },

  beforeMount() {
    this.$service = new ResourceService(`api/solicitacaomovimentacao`)
    this.$serviceTarefa = new ResourceService(`/api/tarefa-solmovibp`);

    this.brand = JSON.parse(localStorage.getItem("context"));
    this.usuario = this.brand.usuario;

    if (verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOV_APROVACAO)) {
      this.exigeLogin = false;
    }

    this.load()

  },

  computed: {
    fieldsTarefas() {
      return [
        { key: "id", label: "Nº" },
        { key: "codStatus.descricao", label: "Status" },
        { key: "codDepartamento.descricao", label: "Unidade Administrativa" },
        { key: "codPessoa.nome", label: "Responsável" },
        { key: "codTipoTarefaSolMovIbp.descricao", label: "Tarefa" },
        {
          key: "dhCriacao",
          label: "Data",
          formatter: value => moment(value).format("DD/MM/yyyy HH:mm"),
        },
        { key: "action", label: "" },
        { key: "detalheTarefa", label: " " },
        { key: "agendamento", label: " " },

      ]
    },

    fieldsItens() {
      return [
        { key: "itemBemPermanente.numTombamento", label: "Nº Tombamento" },
        { key: "itemBemPermanente.itemRegEntrada.produto.numero", label: "Número" },
        {
          key: "itemBemPermanente.itemRegEntrada.produto.descricaoResumida",
          label: "Descrição",
        },
        { key: "departamentoOrigem.descricao", label: "Origem" },
        { key: "departamentoDestino.descricao", label: "UA Destino", },
        { key: "itemBemPermanente.status.descricao", label: "Status", },
        {
          key: "leitura",
          label: "Leitura",
        },
      ]
    },
  },
  methods: {
    mostrarLogin(tarefa) {
      this.tarefa = tarefa;
      this.showLogin = true;
    },
    cancelarLogin() {
      this.tarefa = {};
      this.showLogin = false;
    },


    fecharAgendamento() {
      this.isVisualizarAgendamento = false;
      this.tarefa = {};
      this.mostrarAgendamento = false;
      this.isVisualizacao = false;
      this.load();
    },
    abrirModalAgendamento(item) {
      this.isVisualizarAgendamento = item.codStatus.id == StatusEnum.TAREFA_SOL_MOV_IBP_FINALIZADA.value || item.codStatus.id == StatusEnum.TAREFA_SOL_MOV_IBP_EXPIRADO.value

      this.tarefa = item;
      this.mostrarAgendamento = true;

    },
    isAproavacaoExecucaoRetirada(item) {
      return item.codTipoTarefaSolMovIbp.id == TipoTarefaSolMovIBPEnum.EXECUCAO_RETIRADA.value;
    },

    abrirModalTarefaShow(item) {
      this.cancelarLogin();
      this.idTarefa = item.id;
      this.mostrarTarefaForm = true;

    },
    abrirModalTarefa(item) {

      if (this.exigeLogin) {
        this.mostrarLogin(item);
      }
      else {
        this.abrirModalTarefaShow(item);
      }
    },
    abrirModalTarefaDetalhar(item) {
      this.isVisualizacao = true;
      this.abrirModalTarefa(item);
    },
    fecharModalTarefa() {
      this.idTarefa = null;
      this.isVisualizacao = false;
      this.mostrarTarefaForm = false;
      this.load();
    },
    async iniciarTarefa(item) {
      let response = await this.$confirm(
        `Deseja iniciar esta tarefa (${item.codTipoTarefaSolMovIbp.descricao}) ?`
      )
      if (response) {

        try {
          this.busy = true;
          await this.$serviceTarefa.put("iniciar-tarefa/" + item.id);
          this.busy = false;
          this.$notify({
            type: "success",
            message: "Tarefa iniciada com sucesso!",
          })

          this.abrirModalTarefa(item);
        } catch (error) {
          this.busy = false;
          this.$notify({
            type: "danger",
            message: error,
          });
        }


      }
    },


    isBtnContinuarVisible(data) {

      return data != null && data.codStatus.id == StatusEnum.TAREFA_SOL_MOV_IBP_EM_ANDAMENTO.value && data.codDepartamento.id == this.brand.departamento.id && verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOV_APROVACAO);

    },

    isBtnIniciarVisible(data) {

      return data != null && data.codStatus.id == StatusEnum.TAREFA_SOL_MOV_IBP_AGUARDANDO.value && data.codDepartamento.id == this.brand.departamento.id && verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOV_APROVACAO);

    },


    async load() {
      this.busy = true


      Promise.all([
        this.$service.findById(this.solicitacao.id),
        this.$service.get("tarefas/" + this.solicitacao.id),
      ]).then(response => {
        this.itens = response[0].data.itens;
        this.tarefas = response[1].data;
        this.busy = false
      })
    },

    closeModal() {
      this.$emit("close")
    },

    formatDate(value) {
      return moment(value).format("DD/MM/yyyy")
    },
  },
}
</script>
